<div class="container-scroller">
    <!-- partial:../../partials/_navbar.html -->
    <app-adminheader *ngIf="url != '/admin/login' && url != '/admin/signup' && url != '/admin/forgot-password'"></app-adminheader>
    <!-- partial -->
    <div class="container-fluid" [ngClass]="[(url != '/admin/login' && url!='/admin/signup' && url!='/admin/forgot-password')?'page-body-wrapper':'page-body-wrapper full-page-wrapper']">
      
      <!-- partial:../../partials/_sidebar.html -->
      <nav *ngIf="url != '/admin/login' && url != '/admin/signup' && url != '/admin/forgot-password'" class="sidebar sidebar-offcanvas" id="sidebar">
        <ul class="nav">
          <li class="nav-item">
            <a class="nav-link" routerLink="/admin" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
              <i class="mdi mdi-grid-large menu-icon"></i>
              <span class="menu-title">Dashboard</span>
            </a>
          </li>
          <!-- <li class="nav-item nav-category">Users</li>
          <li class="nav-item">
            <a class="nav-link" data-bs-toggle="collapse" href="#ui-basic" aria-expanded="false" aria-controls="ui-basic">
              <i class="menu-icon mdi mdi-floor-plan"></i>
              <span class="menu-title">Users</span>
              <i class="menu-arrow"></i> 
            </a>
            <div class="collapse" id="ui-basic">
              <ul class="nav flex-column sub-menu">
                <li class="nav-item"> <a class="nav-link" routerLinkActive="active" routerLink="/admin/users">All Users</a></li>
              </ul>
            </div>
          </li> -->
          
          
          <li class="nav-item">
            <a class="nav-link" routerLinkActive="active" routerLink="/admin/users" [routerLinkActiveOptions]="{exact: true}">
              <i class="menu-icon mdi mdi-account text-success"></i>
              <span class="menu-title">Users</span>
            </a>
          </li>
          
          <li class="nav-item">
            <a class="nav-link" routerLink="/admin/subscriptions" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
              <i class="menu-icon mdi mdi-account-key text-primary"></i>
              <span class="menu-title">Subscriptions</span>
            </a>
          </li>
          
          <li class="nav-item">
            <a class="nav-link" routerLink="/admin/categories" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
              <i class="menu-icon mdi mdi-shape text-danger"></i>
              <span class="menu-title">Categories</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/admin/rules" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
              <i class="menu-icon mdi mdi-view-list text-info"></i>
              <span class="menu-title">Rules</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/admin/levels" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
              <i class="menu-icon mdi mdi-filter-variant text-success"></i>
              <span class="menu-title">Levels</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/admin/skills" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
              <i class="menu-icon mdi mdi-format-list-bulleted-type text-primary"></i>
              <span class="menu-title">Skill Types</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/admin/options" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
              <i class="menu-icon mdi mdi-animation text-warning"></i>
              <span class="menu-title">Options</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/admin/option-choices" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
              <i class="menu-icon mdi mdi-format-list-numbered text-danger"></i>
              <span class="menu-title">Option Choices</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/admin/videos" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
              <i class="menu-icon mdi mdi-video"></i>
              <span class="menu-title">Videos</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/admin/instructors" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
              <i class="menu-icon mdi mdi-format-list-bulleted-type text-primary"></i>
              <span class="menu-title">Instructors</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/admin/signatureseries" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
              <i class="menu-icon mdi mdi-format-list-bulleted-type text-primary"></i>
              <span class="menu-title">Signature Series</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/admin/seriesvideos" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
              <i class="menu-icon mdi mdi-format-list-bulleted-type text-primary"></i>
              <span class="menu-title">Series Videos</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/admin/message" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
              <i class="menu-icon mdi mdi-message"></i>
              <span class="menu-title">Message</span>
            </a>
          </li>
          <!-- <li class="nav-item nav-category">help</li>
          <li class="nav-item">
            <a class="nav-link" href="http://bootstrapdash.com/demo/star-admin2-free/docs/documentation.html">
              <i class="menu-icon mdi mdi-file-document"></i>
              <span class="menu-title">Documentation</span>
            </a>
          </li> -->
        </ul>
      </nav>
      <!-- partial -->
      <router-outlet *ngIf="url == '/admin/login' || url == '/admin/signup' || url == '/admin/forgot-password'"></router-outlet>  
      <div class="main-panel" *ngIf="url != '/admin/login' && url != '/admin/signup' && url != '/admin/forgot-password'">
        <div class="content-wrapper">
          <router-outlet></router-outlet>  
        </div>
        <!-- content-wrapper ends -->
        <app-adminfooter></app-adminfooter>
        <!-- partial -->
      </div>
      <!-- main-panel ends -->
    </div>
    <!-- page-body-wrapper ends -->
  </div>

  <app-adminloader></app-adminloader>